// extracted by mini-css-extract-plugin
export default {"match-list-item-label-text":"CompleteMatchesPage_match-list-item-label-text__LgbO5"};